module.exports = __webpack_public_path__ + "static/media/logo.3a0cdc30.svg";